export const configConstants = {
    CONFIG_REQUEST: "CONFIG_REQUEST",
    CONFIG_SUCCESS: "CONFIG_SUCCESS",
    CONFIG_FAILURE: "CONFIG_FAILURE",
}

